import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

const TOUR_STORAGE_KEY = 'discover-tour-completed';

export function useDiscoverTour() {
  const { user } = useAuth();
  const [shouldShowTour, setShouldShowTour] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    async function checkTourStatus() {
      if (!user) {
        setIsChecking(false);
        return;
      }

      // Check if tour was already completed
      const tourCompleted = localStorage.getItem(`${TOUR_STORAGE_KEY}-${user.id}`);
      if (tourCompleted) {
        setShouldShowTour(false);
        setIsChecking(false);
        return;
      }

      // Check if user has rated any books
      const { data: ratings, error } = await supabase
        .from('user_books')
        .select('id')
        .eq('user_id', user.id)
        .not('rating_star', 'is', null)
        .limit(1);

      if (error) {
        console.error('Error checking ratings:', error);
        setIsChecking(false);
        return;
      }

      // Show tour only if user hasn't rated any books
      setShouldShowTour(!ratings || ratings.length === 0);
      setIsChecking(false);
    }

    checkTourStatus();
  }, [user]);

  const completeTour = () => {
    if (user) {
      localStorage.setItem(`${TOUR_STORAGE_KEY}-${user.id}`, 'true');
      setShouldShowTour(false);
    }
  };

  return {
    shouldShowTour,
    isChecking,
    completeTour,
  };
}
